<template>
  <a-card :bordered="false">
    <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="同行价" prop="peerScale">
        <a-input class="input-box" v-model="ruleForm.peerScale" placeholder="请输入"/>
        <span>占亚朵销售价的百分比</span>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 22, offset: 2 }">
        <a-button type="primary" @click="onSave">保存</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
export default {
  name: 'PriceRules',
  data() {
    return {
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
      ruleForm: {
        peerScale: ''
      },
      rules: {
        peerScale: [
          { required: true, message: '请输入同行价', trigger: 'blur' }
        ]
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'AccountSettings', title: '账号设置' },
      { name: 'PriceRules', title: '价格规则' }
    ])
  },
  mounted() {
    this.getYaDuoPriceRule()
  },
  methods: {
    getYaDuoPriceRule() {
      this.getHttpServices().getServerApiService().post('yaduo/manage/findYaDuoPriceRule', ({
        merchantId: this.merchantId,
        platformId: this.platformId
      })).then(res => {
        this.getLogUtils().logWithTag('getYaDuoPriceRule', res)
        this.ruleForm.peerScale = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSave() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.getHttpServices().getServerApiService().post('yaduo/manage/editYaDuoPriceRule', ({
        merchantId: this.merchantId,
        platformId: this.platformId,
        peerScale: this.ruleForm.peerScale
      })).then(res => {
        this.$message.success('保存成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style scoped>
.input-box {
  width: 300px;
  margin-right: 20px;
}
</style>